var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 13.5C18.201 13.5 13.5 18.201 13.5 24C13.5 29.799 18.201 34.5 24 34.5C29.799 34.5 34.5 29.799 34.5 24C34.5 18.201 29.799 13.5 24 13.5ZM10.5 24C10.5 16.5441 16.5442 10.5 24 10.5C31.4558 10.5 37.5 16.5441 37.5 24C37.5 31.4558 31.4558 37.5 24 37.5C16.5442 37.5 10.5 31.4558 10.5 24Z",
    fill: "#03182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 41.4999C23.7239 41.4999 23.5 41.7238 23.5 41.9999C23.5 42.2761 23.7239 42.4999 24 42.4999C24.2761 42.4999 24.5 42.2761 24.5 41.9999C24.5 41.7238 24.2761 41.4999 24 41.4999ZM20.5 41.9999C20.5 40.0669 22.067 38.4999 24 38.4999C25.933 38.4999 27.5 40.0669 27.5 41.9999C27.5 43.9329 25.933 45.4999 24 45.4999C22.067 45.4999 20.5 43.9329 20.5 41.9999Z",
    fill: "#03182F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 5.5C23.7239 5.5 23.5 5.72386 23.5 6C23.5 6.27614 23.7239 6.5 24 6.5C24.2761 6.5 24.5 6.27614 24.5 6C24.5 5.72386 24.2761 5.5 24 5.5ZM20.5 6C20.5 4.067 22.067 2.5 24 2.5C25.933 2.5 27.5 4.067 27.5 6C27.5 7.933 25.933 9.5 24 9.5C22.067 9.5 20.5 7.933 20.5 6Z",
    fill: "#03182F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 23.5C5.72386 23.5 5.5 23.7238 5.5 24C5.5 24.2761 5.72386 24.5 6 24.5C6.27614 24.5 6.5 24.2761 6.5 24C6.5 23.7238 6.27614 23.5 6 23.5ZM2.5 24C2.5 22.067 4.067 20.5 6 20.5C7.933 20.5 9.5 22.067 9.5 24C9.5 25.933 7.933 27.5 6 27.5C4.067 27.5 2.5 25.933 2.5 24Z",
    fill: "#03182F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 23.5C41.7239 23.5 41.5 23.7238 41.5 24C41.5 24.2761 41.7239 24.5 42 24.5C42.2761 24.5 42.5 24.2761 42.5 24C42.5 23.7238 42.2761 23.5 42 23.5ZM38.5 24C38.5 22.067 40.067 20.5 42 20.5C43.933 20.5 45.5 22.067 45.5 24C45.5 25.933 43.933 27.5 42 27.5C40.067 27.5 38.5 25.933 38.5 24Z",
    fill: "#03182F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.02 7.90009C14.7439 7.90009 14.52 8.12394 14.52 8.40009C14.52 8.67623 14.7439 8.90009 15.02 8.90009C15.2962 8.90009 15.52 8.67623 15.52 8.40009C15.52 8.12394 15.2962 7.90009 15.02 7.90009ZM11.52 8.40009C11.52 6.46709 13.087 4.90009 15.02 4.90009C16.953 4.90009 18.52 6.46709 18.52 8.40009C18.52 10.3331 16.953 11.9001 15.02 11.9001C13.087 11.9001 11.52 10.3331 11.52 8.40009Z",
    fill: "#03182F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 39.1C32.7239 39.1 32.5 39.3239 32.5 39.6C32.5 39.8761 32.7239 40.1 33 40.1C33.2761 40.1 33.5 39.8761 33.5 39.6C33.5 39.3239 33.2761 39.1 33 39.1ZM29.5 39.6C29.5 37.667 31.067 36.1 33 36.1C34.933 36.1 36.5 37.667 36.5 39.6C36.5 41.533 34.933 43.1 33 43.1C31.067 43.1 29.5 41.533 29.5 39.6Z",
    fill: "#03182F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31C27.2091 31 29 29.2091 29 27C29 24.7909 27.2091 23 25 23C22.7909 23 21 24.7909 21 27C21 29.2091 22.7909 31 25 31Z",
    fill: "#14C7C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirus);
export default __webpack_public_path__ + "static/media/virus.4c9707f696b045fcbaac6830a7f7c6d7.svg";
export { ForwardRef as ReactComponent };